import type React from "react";

import { ComboboxItem } from "src/primitives/Combobox";
import { isCreateValue } from "./hooks/useCreatableItems";
import type { OptionBase } from "./types";

interface OptionItemProps {
  val: string;
  flatOptionsMap: Map<string, OptionBase>;
  renderOption: (val: string) => React.ReactNode;
  testIdPrefix?: string;
}

export function OptionItem({
  val,
  flatOptionsMap,
  renderOption,
  testIdPrefix,
}: OptionItemProps) {
  const isCreateItem = isCreateValue(val);

  return (
    <ComboboxItem
      key={val}
      value={val}
      disabled={!isCreateItem && flatOptionsMap.get(val)?.disabled}
      className={isCreateItem ? "text-primary" : undefined}
      {...(testIdPrefix
        ? { "data-testid": `${testIdPrefix}-select-option` }
        : {})}
    >
      {renderOption(val)}
    </ComboboxItem>
  );
}
